import { createContext, useContext } from 'react';

export const SharedContext = createContext();

export function useSharedState() {
  return useContext(SharedContext);
}
